/* App.js */

import React from 'react';
import { HashRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/styles.scss';
import AppProvider from './context/Context';
import Routes from './routes/Routes';
import ToastProvider from './providers/ToastProvider';
import Loader from './providers/Loader';
import ScrollToTop from './utils/ScrollToTop';
import CookieConsentProvider from './providers/CookieConsentProvider';

function App() {
  return (
    <AppProvider>
      <HashRouter>
        <ScrollToTop />
        <Loader />
        <Routes />
        <ToastProvider />
        <CookieConsentProvider />
      </HashRouter>
    </AppProvider>
  );
}

export default App;
